import {Injectable} from '@angular/core';
import {ApiService, ApiServiceContext} from '@app/services/api.service';
import {DecisionRequest} from '@app/models/decision-request.model';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ReassignDecisionToModel} from '@app/models/reassign-decision-to.model';

@Injectable({providedIn: 'root'})
export class DecisionsService extends ApiService{

  constructor(ctx: ApiServiceContext){
    super(ctx);
  }

  save(decision: DecisionRequest) : Observable<boolean>{
    return this.http.put('/api/member-decision', decision, {responseType: 'text'}).pipe(
      map(res =>{return res == '1';})
    );
  }

  assignTo(model:ReassignDecisionToModel) : Observable<any>{
    return this.http.put(`/api/member-assignment`, model).pipe(catchError(this.handleError));
  }

  reassign(model:ReassignDecisionToModel) : Observable<any>{
    return this.http.put(`/api/member-assignment/auto`, model).pipe(catchError(this.handleError));
  }

  massiveRespond(ids:number[]) : Observable<any>{
    return this.http.put(`/api/member-decisions`, ids, {responseType: 'text'}).pipe(catchError(this.handleError));
  }
}
